export default __webpack_public_path__ + "static/monkey@2x-83ef7289af6260aa3840201efc3e9a98.png";